export const toModifier = (value: string) => value.toLowerCase().replace(/_/g, '-');

export const CONTENT_ITEM_DIMENSIONS = {
  PORTRAIT: {
    width: 257,
    height: 367
  },
  LANDSCAPE: {
    width: 406,
    height: 229
  },
  SQUARE: {
    width: 138,
    height: 138
  },
  WIDE_LANDSCAPE: {
    width: 554,
    height: 214
  },
  MIXED: {
    width: 406,
    height: 229
  },
  PortraintInLandscape: {
    width: 136,
    height: 194
  },
  PROVIDER_BOX: {
    width: 257,
    height: 168
  }
};
